// store.js

import { createSlice, configureStore } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';
import { combineReducers } from 'redux';

export const authSlice = createSlice({
  name: 'auth',
  initialState: {
    accessToken: null,
    userRole: null,
    isAuthenticated: false,
    isLoading: false,
    userEmailId: localStorage.getItem("userEmailId") || "",
    sessionId: '...',  // add this to your Redux state
    forceLogout: false,

  },
  reducers: {
    setAccessToken: (state, action) => {
      const { accessToken } = action.payload;
      state.accessToken = accessToken;
      state.isAuthenticated = true;
    },
    setIsloading: (state, action) => {
      state.isLoading = action.payload;
    },
    setSessionId: (state, action) => {
      state.sessionId = action.payload;
      localStorage.setItem("sessionId", action.payload); // Keep it in sync
    },
    setUserEmailId: (state, action) => {
      state.userEmailId = action.payload;
      localStorage.setItem("userEmailId", action.payload);
    },
    setUserRole: (state, action) => {
      const { userRole } = action.payload;
      state.userRole = userRole;
    },
    forceLogout: (state) => {
      state.forceLogout = true;
      state.accessToken = null;
      state.userRole = null;
      state.isAuthenticated = false;
      state.sessionId = null;
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("userEmailId");
    },
    
    logout: (state) => {
      state.accessToken = null;
      state.userRole = null;
      state.isAuthenticated = false;
      state.userEmailId = false;
      localStorage.removeItem("userEmailId");
    },
  },
});

export const authenticateActions = authSlice.actions;

// ✅ Combine reducers
const rootReducer = combineReducers({
  auth: authSlice.reducer,
});

// ✅ Main persist config
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth'],
};

// ✅ Wrap the *entire* rootReducer here
const persistedReducer = persistReducer(persistConfig, rootReducer);

// ✅ Configure store with persisted reducer
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});

// ✅ Persistor
export const persistor = persistStore(store);
